
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import "./style.css";
import FileUploader from "./FileUploader";
import apiClient from "../../utils/apiClient";
import { imageBaseurl } from "../../utils/common";
import { toast } from "react-toastify";

const JobEdit = () => {
  const navigate = useNavigate();
  const editor = useRef(null);

  const [input, setInput] = useState({
    title: "",
    slug: "",
    image: null,
    imageShow: null,
    des: "",
    active: 0,
    type: "blog",
    pagetitle: "",
    metades: "",
    metakey: "",
    author: "",
    category: "",
    tags: "",
    publishedDate: "",
    updatedDate: ""
  });

  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let errors = {};
    if (!input.title.trim()) errors.title = "Title is required";
    if (!input.slug.trim()) errors.slug = "Slug is required";
    if (!input.type) errors.type = "Type is required";
    if (!input.pagetitle.trim()) errors.pagetitle = "Page title is required";
    if (!input.metades.trim()) errors.metades = "Meta description is required";
    if (!input.metakey.trim()) errors.metakey = "Meta keywords are required";
    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    if (e.target.files.length !== 0) {
      setInput({
        ...input,
        image: e.target.files[0],
        imageShow: URL.createObjectURL(e.target.files[0]),
      });
    }
  };
  const config = {
    readonly: false,
    height: 500,
  };

  const { jobId } = useParams();

  const routeChange = (page) => {
    navigate(page);
  };

  useEffect(() => {
    if (jobId) getDetails();
  }, [jobId]);

  const getDetails = async () => {
    try {
      const response = await apiClient.get(`/api/blog/${jobId}`);
      setInput({ ...response.data.data, imageShow: imageBaseurl + response?.data?.data?.image });
    } catch (error) {
      console.error("Error fetching post details:", error);
    }
  };

  const updateJob = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(input).forEach((key) => {
        if (key !== "imageShow") {
          formData.append(key, input[key]);
        }
      });
      await apiClient.put(`/api/blog/${jobId}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success('Blog updated successfully')
      setTimeout(() => {
        navigate("/blog");
      }, 1000)

    } catch (error) {
      toast.error(error.response?.data?.message || "Server error!")
      console.error("Error adding job:", error);
    }
    setLoading(false);
  };

  return (
    <>
      <FileUploader />
      <div className="container my-5">
        <div className="card shadow-lg">
          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">Update Post</h3>
          </div>
          <div className="card-body">
            <div className="row g-3">
              {/* <div className="col-md-6">
                <div className="form-group">
                  <label>Type</label>
                  <small className="form-text text-muted">Defines the type of the post.</small>
                  <select name="type" value={input.type} onChange={handleInputChange} className="form-control">
                    <option value="">Select Type</option>
                    {postType.map((res) => (
                      <option key={res.value} value={res.value}>{res.name}</option>
                    ))}
                  </select>
                  {formError.type && <div className="text-danger">{formError.type}</div>}
                </div>
              </div> */}

              <div className="col-md-6">
                <div className="form-group">
                  <label>Title</label>
                  <small className="form-text text-muted">Represents the headline of the job post.</small>
                  <input type="text" name="title" value={input.title} onChange={handleInputChange} className="form-control" />
                  {formError.title && <div className="text-danger">{formError.title}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Slug</label>
                  <small className="form-text text-muted">SEO-friendly URL identifier.</small>
                  <input type="text" name="slug" value={input.slug} onChange={handleInputChange} className="form-control" onBlur={() => {
                    setInput({
                      ...input,
                      slug: input.slug.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, ''),
                    });
                  }} />
                  {formError.slug && <div className="text-danger">{formError.slug}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Meta Page Title</label>
                  <small className="form-text text-muted">Appears as the title in search engine results.</small>
                  <input type="text" name="pagetitle" value={input.pagetitle} onChange={handleInputChange} className="form-control" />
                  {formError.pagetitle && <div className="text-danger">{formError.pagetitle}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Meta Description</label>
                  <small className="form-text text-muted">Summarizes the content for search engines.</small>
                  <input type="text" name="metades" value={input.metades} onChange={handleInputChange} className="form-control" />
                  {formError.metades && <div className="text-danger">{formError.metades}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Meta Keywords</label>
                  <small className="form-text text-muted">Keywords to improve search ranking.</small>
                  <input type="text" name="metakey" value={input.metakey} onChange={handleInputChange} className="form-control" />
                  {formError.metakey && <div className="text-danger">{formError.metakey}</div>}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Author</label>
                  <small className="form-text text-muted">Person who created the post (SEO for authorship).</small>
                  <input type="text" name="author" value={input.author} onChange={handleInputChange} className="form-control" />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Category</label>
                  <small className="form-text text-muted">Organizes posts under a specific topic.</small>
                  <input type="text" name="category" value={input.category} onChange={handleInputChange} className="form-control" />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Tags</label>
                  <small className="form-text text-muted">Relevant keywords to improve discoverability.</small>
                  <input type="text" name="tags" value={input.tags} onChange={handleInputChange} className="form-control" />
                </div>
              </div>

              {/* <div className="col-md-6">
                <div className="form-group">
                  <label>Published Date {input.publishedDate}</label>
                  <small className="form-text text-muted">Date when the post was published (helps Google understand freshness).</small>
                  <input type="date" name="publishedDate" value={input.publishedDate} onChange={handleInputChange} className="form-control" />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Updated Date {input.updatedDate}</label>
                  <small className="form-text text-muted">Date of last modification (good for SEO updates).</small>
                  <input type="date" name="updatedDate" value={input.updatedDate} onChange={handleInputChange} className="form-control" />
                </div>
              </div> */}

              <div className="col-md-6">
                <div className="form-group">
                  <label>Status</label>
                  <small className="form-text text-muted">Indicates whether the post is active or inactive.</small>
                  <select name="active" value={input.active} onChange={handleInputChange} className="form-control">
                    <option value={true}>Active</option>
                    <option value={false}>Inactive</option>
                  </select>
                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  {input.imageShow && <img src={input.imageShow} alt="Preview" className="img-fluid mb-3" style={{ maxWidth: "50%" }} />}
                  <label>Image</label>
                  <small className="form-text text-muted">Thumbnail for the job post (use optimized images for better SEO).</small>
                  <input type="file" onChange={handleImageChange} className="form-control-file" />
                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <label>Job Description</label>
                  <small className="form-text text-muted">Detailed content about the job.</small>
                  <JoditEditor config={config} ref={editor} value={input.des} onBlur={(newContent) => setInput({ ...input, des: newContent })} />
                </div>
              </div>

              <div className="col-12 text-center">
                <button className="btn btn-primary btn-lg me-2" onClick={updateJob}>
                  Update
                </button>
                <button className="btn btn-secondary btn-lg" onClick={() => routeChange("/blog")}>
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div></>
  );
};

export default JobEdit;